import { Component, Inject, Optional } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { IJurisdiction, Jurisdiction } from '../../../../../foundation/models/enums/jurisdiction.enum';
import { SourceSystemType } from '../../../../../foundation/models/enums/source-system-type.enum';
import { BaseComponent } from '../../../../../shared/base-components/base.component';
import { IRouteBuilder } from '../../../../../shared/services/route-builder/route-builder.interface';
import { VehicleOwnershipSoldNoticeModel } from '../../../../../titleregistration/models/vehicle-ownership-sold-notice.model';
import { VehicleOwnershipModel } from '../../../../../titleregistration/models/vehicle-ownership.model';
import { SoldNoticeService } from '../../../../../titleregistration/services/sold-notice.service';

export class IssueSoldNoticeModalData {
    constructor(public vehicleId: number, public customerNumberId: number) {}
}

@Component({
    selector: 'issue-sold-notice-modal',
    templateUrl: './issue-sold-notice-modal.html'
})
export class IssueSoldNoticeModalComponent extends BaseComponent {
    public dataLoaded = false;
    public form: UntypedFormGroup;
    public jurisdictions: IJurisdiction[];
    public createSoldNoticeRefundResult: any;
    private routeBuilder: IRouteBuilder;
    private sourceSystemTypes: SourceSystemType = new SourceSystemType();
    private vehicleOwnershipId: number;

    constructor(
        public dialogRef: MatDialogRef<IssueSoldNoticeModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: IssueSoldNoticeModalData,
        private soldNoticeService: SoldNoticeService,
        private fb: UntypedFormBuilder
    ) {
        super();
        this.jurisdictions = new Jurisdiction().GetAll();
        this.routeBuilder = this.routeBuilderFactory.create(this.sourceSystemTypes.TitleRegistration.id);
    }

    // Initialize the class
    ngOnInit(): void {
        this.soldNoticeService.getOwnershipsByVehicleId(this.data.vehicleId).subscribe(
            r => {
                let ownerships = r as VehicleOwnershipModel[];
                this.vehicleOwnershipId = ownerships[0].id;

                this.form = this.fb.group({
                    'dateOfSale': [null, Validators.required],
                    'buyersName': [null, Validators.required],
                    'isBuyerUnknown': [false],
                    'isAddressUnknown': [false],
                    'addressLine1': [null, Validators.required],
                    'addressLine2': [null],
                    'city': [null],
                    'jurisdictionId': [null],
                    'postalZipCode': [null]
                });

                this.dataLoaded = true;
            },
            err => {
                this.handleValidationResult(err);
            }
        );
    }

    cancel(): void {
        if (this.createSoldNoticeRefundResult) {
            this.dialogRef.close(true);
        } else {
            this.dialogRef.close();
        }
    }

    startRegistrationCredit(): void {
        this.dialogRef.close(this.createSoldNoticeRefundResult);
    }

    saveSoldNotice(): void {
        this.form.markAllAsTouched();
        if (this.form.valid) {
            let soldNoticeModel = new VehicleOwnershipSoldNoticeModel();
            soldNoticeModel = this.form.getRawValue();
            soldNoticeModel.vehicleOwnershipId = this.vehicleOwnershipId;
            this.soldNoticeService.createSoldNotice(soldNoticeModel).subscribe(r => {
                if (r.refundTotal && r.refundTotal > 0) {
                    this.form.get('dateOfSale').disable();
                    this.form.get('jurisdictionId').disable();
                    this.createSoldNoticeRefundResult = r;
                } else {
                    this.dialogRef.close(true);
                }
            }, err => {
                this.handleValidationResult(err);
            });
        }
    }

    unknownBuyerClicked(): void {
        let value = this.form.get('isBuyerUnknown').value;
        if (value) {
            this.form.get('buyersName').setValue('Unknown');
        } else {
            this.form.get('buyersName').setValue(null);
        }
    }

    unknownAddressClicked(): void {
        let value = this.form.get('isAddressUnknown').value;
        let addressLine1Control = this.form.get('addressLine1');
        let addressLine2Control = this.form.get('addressLine2');
        let cityControl = this.form.get('city');
        let jurisdictionIdControl = this.form.get('jurisdictionId');
        let postalZipCodeControl = this.form.get('postalZipCode');
        if (value) {
            addressLine1Control.setValue('Unknown');
            addressLine2Control.setValue(null);
            cityControl.setValue(null);
            cityControl.clearValidators();
            cityControl.updateValueAndValidity();
            jurisdictionIdControl.setValue(null);
            jurisdictionIdControl.clearValidators();
            jurisdictionIdControl.updateValueAndValidity();
            postalZipCodeControl.setValue(null);
            postalZipCodeControl.clearValidators();
            postalZipCodeControl.updateValueAndValidity();
        } else {
            addressLine1Control.setValue(null);
            addressLine1Control.setValidators(Validators.required);
            addressLine1Control.updateValueAndValidity();
            cityControl.setValidators(Validators.required);
            cityControl.updateValueAndValidity();
            jurisdictionIdControl.setValidators(Validators.required);
            jurisdictionIdControl.updateValueAndValidity();
            postalZipCodeControl.setValidators(Validators.required);
            postalZipCodeControl.updateValueAndValidity();
        }
    }
}
